import { render, staticRenderFns } from "./MailingViewTemplateGuideDlg.vue?vue&type=template&id=19353f82&"
import script from "./MailingViewTemplateGuideDlg.vue?vue&type=script&lang=js&"
export * from "./MailingViewTemplateGuideDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports